export const MEDIA_XSMALL = 376;
export const MEDIA_SMALL = 768;
export const MEDIA_MEDIUM = 1024;
export const MEDIA_LARGE = 1280;
export const MEDIA_XLARGE = 1440;

export const MEDIA_SMALL_FONT_RATIO = 1200;
export const MEDIA_TABLET = 1000;
export const MEDIA_MOBILE = 580;
